import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./MedicalSummaryViewChanges.module.scss";

interface IMedicalSummaryViewChangesPopupProps {
    onClose: () => void;
    onContinue: () => void;
}

function MedicalSummaryViewChangesPopup(props: IMedicalSummaryViewChangesPopupProps): JSX.Element {
    const { getText } = useTranslation();

    function renderFooter(): JSX.Element {
        return (
            <div className="p-footer">
                <div className="space-between">
                    <div className="styles.buttons-display flex-container flex-end">
                        <button
                            className="btn btn-default margin-sm-left"
                            onClick={() => props.onClose()}
                        >
                            {getText("CancelLabel")}
                        </button>
                        <button
                            className="btn btn-primary margin-sm-left"
                            onClick={() => props.onContinue()}
                        >
                            {getText("ContinueLabel")}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Modal
            showX
            centerContent
            draggable
            title={getText("ConfigureSummary_ViewChangesModalTitle")}
            width={570}
            maxHeight="180px"
            top={1}
            showOverlay
            onClose={() => props.onClose()}
            footer={renderFooter()}
        >
            <div className={`${styles.modalContentWrapper} margin-xs-top`}>
                <div>
                    <p>{getText("ConfigureSummary_ConfirmViewChangesLabel")}</p>
                </div>
                <div>
                    <p>{getText("DoYouWantToContinueLabel")}</p>
                </div>
            </div>
        </Modal>
    );
}

export { IMedicalSummaryViewChangesPopupProps, MedicalSummaryViewChangesPopup };
